export default __webpack_public_path__ + "static/media/Katja@2x.417a0815.jpg";